@if (state?.isPinned) {
    <div class="pinned-banner" id="pinned-banner">
        Showing {{ state.searchTotal }} affected records.
        <button mat-button mgdButton id="mat-pinned-clear-button" (click)="state.clearPinnedModels()">Clear</button>
    </div>
}
@if (appState.processing$ | async) {
    <mat-icon>search_activity</mat-icon>
    <span class="empty-state-warning">Loading...</span>
} @else {
    <mat-icon>search_off</mat-icon>
    <span class="empty-state-warning">
        <ng-content> No Results Found</ng-content>
    </span>
}